import { Benefit } from '@/components/blocks/Benefits/parts/Benefit';
import {
	BenefitsContainerItemSX,
	BenefitsFrameSX,
	BenefitsTitleSX,
} from '@/components/blocks/Benefits/styles/container';
import {
	DpBenefitsProvider,
	useDpBenefits,
	useDpBenefitsContext,
} from '@/components/blocks/DpBenefitsContext';
import { DpBottomContainer } from '@/components/blocks/DpBottomContainer';
import { DrawerBenefit } from '@/components/blocks/DpDrawerBenefit';
import { DpH4Dis } from '@/components/blocks/DpLibrary/DpH4';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { combineSX } from '@/utils/combineSX';
import { Grid, SxProps } from '@mui/material';
import { Fragment } from 'react';

interface DpBenefitsFrameProps {
	title?: string;
	framesx?: SxProps;
	nocontainer?: boolean;
	children?: React.ReactNode;
}

export const DpBenefitsFrame: React.FC<DpBenefitsFrameProps> = ({
	framesx,
	nocontainer,
	children,
	title,
}) => {
	const isTablet = useIsMobile();

	return (
		<DpBottomContainer
			nocontainer={nocontainer}
			framesx={combineSX([BenefitsFrameSX, ...(Array.isArray(framesx) ? framesx : [framesx])])}
		>
			<Grid container>
				{!isTablet ? (
					<Grid xs={12} item>
						<DpH4Dis sx={BenefitsTitleSX}>{title ?? 'BENEFICIOS DE COMPRAR EN DPORTENIS'}</DpH4Dis>
					</Grid>
				) : null}
				<Grid
					item
					container
					xs={12}
					sx={{
						...BenefitsContainerItemSX,
						display: 'grid',
						gridTemplateColumns: 'repeat(2,1fr)',
						gap: '17px',
						'@media(min-width:960px)': {
							gridTemplateColumns: 'repeat(4,1fr)',
						},
					}}
				>
					{children}
				</Grid>
			</Grid>
		</DpBottomContainer>
	);
};

export const DpBenefit: React.FC<{
	title: string;
	description: string;
	src: string;
	spot: string;
}> = ({ title, description, src, spot }) => {
	const { onOpenDrawer } = useDpBenefitsContext();
	const isTablet = useIsMobile();

	return (
		<Benefit
			title={title}
			description={description}
			imgSrc={src}
			isTablet={isTablet}
			onClick={() =>
				onOpenDrawer({
					title,
					emsName: spot,
				})
			}
		/>
	);
};

export const DpBenefitsDrawer = () => {
	const { openDrawer, onCloseDrawer } = useDpBenefitsContext();

	return (
		<DrawerBenefit
			open={!!openDrawer}
			title={openDrawer?.title || ''}
			emsName={openDrawer?.emsName || ''}
			onClose={onCloseDrawer}
		/>
	);
};

export const DpBenefits: React.FC<DpBenefitsFrameProps> = ({ children, ...props }) => {
	const dpBenefits = useDpBenefits();

	return (
		<DpBenefitsProvider value={dpBenefits}>
			<DpBenefitsFrame {...props}>
				{children ? (
					<Fragment>{children}</Fragment>
				) : (
					<Fragment>
						<DpBenefit
							title="30 días para devoluciones"
							description="En línea o en tienda"
							src="EmeraldSAS/images/promotion/devolucion.png"
							spot="DrawerReturnsExchangesInformative"
						/>

						<DpBenefit
							title="Envío gratis a todo México"
							description="en compras mayores a $999"
							src="EmeraldSAS/images/promotion/envio-gratis.png"
							spot="DrawerDeliveriesShipmentsInformative"
						/>

						<DpBenefit
							title="Compra en línea y paga en efectivo"
							description="OXXO y BBVA"
							src="EmeraldSAS/images/promotion/pago-linea.png"
							spot="DrawerPaymentMethodsInformative"
						/>

						<DpBenefit
							title="Hasta 9 MSI con tarjetas de crédito"
							description="Pagando con tarjetas participantes*."
							src="EmeraldSAS/images/promotion/msi.png"
							spot="DrawerHowToBuy"
						/>
					</Fragment>
				)}
			</DpBenefitsFrame>
			<DpBenefitsDrawer />
		</DpBenefitsProvider>
	);
};
